import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const huntress = defineConnector({
  identifier: "huntress",
  name: "Huntress",
  tagLine: "Managed detection and response",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.huntress\\.io/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: app.secret.apiSecret,
    }),
  steps: [
    {
      title: "Generate API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Huntress dashboard](https://huntress.io/), open **Account Settings › API Credentials** and generate a new key. Copy the API key and API secret key — the secret is shown only once.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret key",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.huntress.io/v1/account",
  },
});
